import React from "react";
import { Calendar, MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
import siteUrl from "../../../../const/const";
import imgs from "../../../../assets/img/img";
import { fmtDate } from "./utils";

const EventCard: React.FC<{
  event: any;
  showStatus?: boolean;
  onClick: () => void;
}> = ({ event, showStatus, onClick }) => (
  <div
 className="group relative overflow-hidden rounded-xl border border-gray-100 dark:border-gray-800 hover:shadow-md transition-all duration-300 flex flex-row h-[90px] cursor-pointer"
    onClick={onClick}
  >
    {showStatus && (
      <span
        className={cn(
          "absolute top-2 right-2 z-10 text-[10px] font-bold px-2 py-0.5 rounded-full",
          event.isApproved ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
        )}
      >
        {event.isApproved ? "Təsdiqlənib" : "Gözlənilir"}
      </span>
    )}
    <div className="relative w-28 flex-shrink-0 overflow-hidden border-r border-gray-50">
      <img
        src={event.media ? `${siteUrl}images/${event.media.folder || "users"}/${event.media.name}` : imgs.header}
        alt={event.name}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
    <div className="p-3 flex flex-col justify-center min-w-0 flex-1">
      <h3 className="font-bold text-gray-900 dark:text-gray-50 line-clamp-1 group-hover:text-blue-500 transition-colors leading-snug mb-1 text-sm dark:group-hover:text-indigo-200">
        {event.name}
      </h3>
      <div className="flex flex-col gap-1 text-[11px] font-medium text-gray-400 dark:text-gray-500">
        {event.date && (
          <div className="flex items-center gap-2">
            <Calendar className="w-3 h-3 text-blue-500/60" />
            {fmtDate(event.date)}
          </div>
        )}
        {event.location && (
          <div className="flex items-center gap-2">
            <MapPin className="w-3 h-3 text-blue-500/60 flex-shrink-0" />
            <span className="truncate">{event.location}</span>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default EventCard;
